import { useEffect, useMemo, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import "../DocumentModal/Documents.css";
import "../common/CustomModal/CustomDocumentModal.css";
import "../DocumentModal/DocumentModal.css";
// import { pdfjs } from "react-pdf";

import { getCaseId, getClientId, getToken } from "../../Utils/helper";
import { useDocumentModal } from "../common/CustomModal/CustomModalContext";
import CustomClientSearch from "../common/CustomModal/CustomClientSearch";
import CustomPdfThumbnail from "../common/CustomModal/CustomPdfThumbnail";
import PdfNavigation from "../DocumentModal/PdfNavigation";
import api, { api_without_cancellation } from "../../api/api";
import { useChat } from "../AChatWindow/hooks/useChat";
import { setSelectedUser } from "../../Redux/new-chat-store/chatSlice";
import ChatWindow from "../AChatWindow/components/ChatWindow";

import DocumentModalSideBar from "./DocumentSideBar/DocumentModalSideBar";

const DocumentModal = () => {
  const [updatedUser, setUpdatedUser] = useState({});
  const [chatDocumentThread, setChatDocumentThread] = useState(false);

  const {
    documentURL,
    isPhotoModal,
    documentURLfordownload,
    hideDocumentModal,
    documentData,
    photoListData,
    setDocumentURL,
    setDocumentData,
  } = useDocumentModal();

  const {
    firms,
    selectedFirm,
    users,
    loading: chatLoading,
    error: chatError,
    handleSelectFirm,
    sendMessage,
    searchUsers,
    messages,
    typingUsers,
    handleTyping,
    markAsRead,
    loadMoreMessages,
    handleSelectUser,
  } = useChat({ skipInitialization: true });
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);
  const [containerRef, setContainerRef] = useState(null);
  const imageRef = useRef();
  const [zoomLevel, setZoomLevel] = useState(1);
  const [zoomMode, setZoomMode] = useState("fit");
  const [pageDimensions, setPageDimensions] = useState({
    width: 0,
    height: 0,
  });

  const source = "";
  const threadId = "";
  // if (documentURL !== "") {
  //   const urlObj = new URL(documentURL);
  //   const params = new URLSearchParams(urlObj.search);
  //   // eslint-disable-next-line unused-imports/no-unused-vars
  //   threadId = params?.get("thread_id");
  //   source = params?.get("source");
  // }
  useEffect(() => {
    if (!users || users.length === 0 || documentURL === "") return; // wait until users arrive
    const urlObj = new URL(documentURL);
    const params = new URLSearchParams(urlObj.search);

    const threadId = params.get("thread_id");

    const selectedUser = users.find((u) => u.id === threadId);
    if (!selectedUser) return;

    const updatedUser = {
      ...selectedUser,
      threadId,
    };

    setSelectedUser(selectedUser);
    setUpdatedUser(updatedUser);
  }, [users, threadId]);

  const data = useMemo(() => {
    const photos = Array.isArray(photoListData?.results)
      ? photoListData.results
      : Array.isArray(photoListData)
        ? photoListData.flatMap((item) => item.page_docs || (item.image ? [item] : []))
        : [];
    return photos.length ? photos : documentURL ? [{ ...documentData, image: documentURL }] : [];
  }, [photoListData, documentData, documentURL]);
  const numPages = data.length;

  useEffect(() => {
    const index = data.findIndex((photo) => photo.image === documentURL);
    if (index >= 0) setPage(index + 1);
  }, [data, documentURL]);

  useEffect(() => {
    setPageDimensions({ width: 0, height: 0 });
    setZoomMode("fit");
  }, [documentURL, isPhotoModal]);

  useEffect(() => {
    if (
      !isPhotoModal ||
      !containerRef ||
      !pageDimensions.width ||
      !pageDimensions.height ||
      !zoomMode
    )
      return;

    const fitImage = () => {
      const width = containerRef.clientWidth;
      const height = containerRef.clientHeight;
      if (!width || !height) return;
      const widthScale = width / pageDimensions.width;
      const heightScale = height / pageDimensions.height;
      setZoomLevel(
        zoomMode === "width"
          ? widthScale
          : zoomMode === "height"
            ? heightScale
            : Math.min(widthScale, heightScale)
      );
    };

    fitImage();
    const resizeObserver = new ResizeObserver(fitImage);
    resizeObserver.observe(containerRef);
    return () => resizeObserver.disconnect();
  }, [containerRef, pageDimensions, zoomMode, isPhotoModal]);

  const onZoomChange = (zoomType) => {
    if (["width", "height", "fit"].includes(zoomType)) {
      setZoomMode(zoomType);
      return;
    }
    switch (zoomType) {
      case "in":
        setZoomMode("");
        setZoomLevel((prevZoom) => Math.max(prevZoom, Math.min(prevZoom + 0.1, 4)));
        break;
      case "out":
        setZoomMode("");
        setZoomLevel((prevZoom) => Math.min(prevZoom, Math.max(prevZoom - 0.1, 0.1)));
        break;
      default:
        if (typeof zoomType === "number" && Number.isFinite(zoomType) && zoomType > 0) {
          setZoomMode("");
          setZoomLevel(zoomType);
        }
        break;
    }
  };

  // async function onDocumentLoadSuccess(pdf) {
  //   setNumPages(pdf?.numPages || 0);
  //   setError("");
  // }

  function scrollPageToView(pageNumber, updatePageNumber = (pageNumber) => pageNumber) {
    if (!Number.isInteger(pageNumber) || pageNumber < 1 || pageNumber > data.length) return;
    const photo = data[pageNumber - 1];
    document.getElementById(`pdf_page_${pageNumber}`)?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
    updatePageNumber(pageNumber);
    setDocumentData(photo);
    setDocumentURL(photo.image);
  }

  // const onPageLoadSuccess = (page) => {
  //   const { width, height } = page.getViewport({ scale: 1 });
  //   setPageDimensions({
  //     width: width,
  //     height: height,
  //   });
  // };

  // const searchResult = usePdfTextSearch(documentURL, debouncedSearchString);

  // useEffect(() => {
  //   if (searchResult.length > 0) {
  //     const pageNumber = searchResult[0];
  //     scrollPageToView(pageNumber);
  //   }
  // }, [searchResult]);

  const token = getToken();
  const [loading, setLoading] = useState(false);
  const [slotsData, setSlotsData] = useState([]);
  useEffect(() => {
    const fetchDataFirstTime = async () => {
      try {
        setLoading(true);
        const response = await api.get("/api/photo/photos-page-rows/", {
          params: {
            page_id: "",
            case_id: Object.keys(documentData).length ? documentData?.for_case?.id : getCaseId(),
            client_id: Object.keys(documentData).length
              ? documentData?.for_client?.id
              : getClientId(),
          },
        });
        if (response.status === 200) {
          setSlotsData(response.data.data);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    if (token) {
      fetchDataFirstTime();
    }
  }, [documentData?.for_case?.id, token, documentData]);

  const abortControllerRef = useRef(null);

  const refetchSlotsData = async () => {
    // Abort the previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    // Create a new controller
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const response = await api_without_cancellation.get("/api/photo/photos-page-rows/", {
        params: {
          page_id: "",
          case_id: documentData?.for_case?.id || "",

          client_id: documentData?.for_client?.id || "",
        },
        signal: controller.signal,
      });

      if (response.status === 200) {
        setSlotsData(response.data.data);
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Previous API call aborted.");
      } else {
        console.error("API error:", error);
      }
    }
  };

  return (
    <Modal
      show={isPhotoModal}
      // onHide={hideDocumentModal}
      onHide={() => {
        setChatDocumentThread(false);
        hideDocumentModal();
      }}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="universal-document-modal custom-modal-width"
      dialogClassName="document-modal-padding-setting"
      // style={{ padding: 0 }}
    >
      <Modal.Header
        className="document-modal-header d-flex align-items-center justify-content-center height-25"
        style={{ borderRadius: "0px", borderBottom: "none" }}
      >
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "uppercase",
          }}
          className="d-flex align-items-center justify-content-center height-25"
        >
          Photo Viewer
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="document-modal-body">
        <div
          className="document-viewer-shell d-flex flex-column justify-content-between m-0"
          style={{
            width: "100%",
            minWidth: 0,
          }}
        >
          <div
            className="document-viewer-content d-flex"
            style={{
              width: "100%",
              minWidth: 0,
            }}
          >
            {source !== "" && source !== "chat" && (
              <CustomPdfThumbnail
                documentURL={documentURL}
                numPages={numPages}
                currentPage={page}
                onThumbnailClick={scrollPageToView}
                setPageNumber={setPage}
                photoListData={photoListData}
                isPdf={false}
              />
            )}
            <div className="d-flex flex-column" style={{ flex: 1, minHeight: 0, minWidth: 0 }}>
              <div className="search-and-error-area" style={{ flexShrink: 0 }}>
                {error && <div className="alert alert-danger">{error}</div>}
                <CustomClientSearch setError={setError} />
              </div>

              <div
                className=" main-doc-area m-0"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  minHeight: 0,
                  height: "auto",
                  width: "100%",
                  overflowY: "scroll",
                  overflowX: "auto",
                  backgroundColor: "var(--primary-20)",
                  scrollbarWidth: "none",
                }}
                ref={setContainerRef}
              >
                <img
                  key={documentURL}
                  src={documentURL}
                  className="photo-url center"
                  alt={documentData?.file_name || "Photo preview"}
                  onLoad={(event) => {
                    setPageDimensions({
                      width: event.currentTarget.naturalWidth,
                      height: event.currentTarget.naturalHeight,
                    });
                  }}
                  style={{
                    width: pageDimensions.width ? `${pageDimensions.width * zoomLevel}px` : "auto",
                    maxWidth: "none",
                    height: "auto",
                    flexShrink: 0,
                    margin: "auto",
                  }}
                  ref={imageRef}
                />
              </div>
            </div>
            <DocumentModalSideBar
              documentData={documentData}
              documentURL={documentURL}
              photoListData={photoListData}
              imageRef={imageRef}
              // hideDocumentModal={hideDocumentModal}
              hideDocumentModal={() => {
                setChatDocumentThread(false);
                hideDocumentModal();
              }}
              documentURLfordownload={documentURLfordownload}
              pageNumber={page}
              slotsData={slotsData}
              onRefetchSlotsData={refetchSlotsData}
              loading={loading}
              setSlotsData={setSlotsData}
              firms={firms}
              selectedFirm={selectedFirm}
              users={users}
              chatLoading={chatLoading}
              chatError={chatError}
              handleSelectFirm={handleSelectFirm}
              sendMessage={sendMessage}
              searchUsers={searchUsers}
              setChatDocumentThread={setChatDocumentThread}
              setUpdatedUser={setUpdatedUser}
              handleSelectUser={handleSelectUser}
            />
          </div>
          <PdfNavigation
            alignWithDocument
            documentViewport={containerRef}
            showSearch={false}
            totalPages={numPages}
            pageNumber={page}
            setPageNumber={setPage}
            onZoomChange={onZoomChange}
            zoomScale={zoomLevel}
            scrollPageToView={scrollPageToView}
            isChatOpen={(threadId && updatedUser) || (chatDocumentThread && updatedUser)}
          />
        </div>
        {threadId && updatedUser && (
          <div
            style={{
              minWidth: "200px",
              flex: "0 0 30%",
            }}
          >
            <ChatWindow
              user={updatedUser}
              messages={messages}
              typingUsers={typingUsers}
              sendMessage={sendMessage}
              handleTyping={handleTyping}
              markAsRead={markAsRead}
              handleSendMessage={(text) => sendMessage(updatedUser?.id, text)}
              loadMoreMessages={loadMoreMessages}
              source={source}
            />
          </div>
        )}
        {chatDocumentThread && updatedUser && (
          <div
            style={{
              minWidth: "200px",
              flex: "0 0 30%",
            }}
          >
            <ChatWindow
              user={updatedUser}
              messages={messages}
              typingUsers={typingUsers}
              sendMessage={sendMessage}
              handleTyping={handleTyping}
              markAsRead={markAsRead}
              handleSendMessage={(text) => sendMessage(updatedUser?.id, text)}
              loadMoreMessages={loadMoreMessages}
              source={"chat"}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer
        style={{
          margin: 0,
          padding: 0,
          border: 0,
        }}
      />
    </Modal>
  );
};

export default DocumentModal;
